import React from "react";
import {Link, useTheme} from "@mui/material";
import {NavLink} from "react-router-dom";

function Logo(props) {
    const {width} = props;
    const theme = useTheme();
    return (
        <div>
            <Link color="inherit" component={NavLink} to="/">
                <img src={`${(process.env.PUBLIC_URL || '').replace(/^\.$/, '')}/logo.svg`} alt="Skro" width={width}
                     style={{display: 'block', filter: theme.palette.mode === "light" ? "brightness(0)" : "none"}}/>
            </Link>
        </div>
    );
}

export default Logo;